import { Grid, TextField } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import { Skeleton } from '@material-ui/lab';
import React, { FC } from 'react';
import DeliveryOrder from 'src/interfaces/api/DeliveryOrder';

interface Props {
  loading: boolean;
}

const AddressFields: FC<Props> = ({ loading }) => {
  const { control } = useFormContext<DeliveryOrder>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={8}>
        <Controller
          name='address'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field: { value, ...others }, fieldState: { error } }) =>
            loading ? (
              <Skeleton height={56} />
            ) : (
              <TextField
                {...others}
                value={value || ''}
                label='Adresse'
                variant='outlined'
                fullWidth
                required
                error={undefined !== error}
                helperText={error?.message}
              />
            )
          }
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <Controller
          name='city'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field: { value, ...others }, fieldState: { error } }) =>
            loading ? (
              <Skeleton height={56} />
            ) : (
              <TextField
                {...others}
                value={value || ''}
                label='Ville'
                variant='outlined'
                fullWidth
                required
                error={undefined !== error}
                helperText={error?.message}
              />
            )
          }
        />
      </Grid>
    </Grid>
  );
};

export default AddressFields;
